const mac =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPod|iPad/.test(navigator.userAgent)

/**
 * Formats a keyboard shortcut for display, using ⌘ on Mac and Ctrl on other platforms.
 * Pass the key portion without the modifier, e.g. "B", "Shift+X".
 */
export function formatShortcut(key: string): string {
  if (mac) {
    // On Mac: ⌘B, ⇧⌘X
    const parts = key.split("+")
    const mainKey = parts.pop()!
    const modifiers = parts.map(m => {
      if (m === "Shift") return "⇧"
      if (m === "Alt") return "⌥"
      return m
    })
    return [...modifiers, "⌘", mainKey].join("")
  }

  // On Windows/Linux: Ctrl+B, Ctrl+Shift+X
  const parts = key.split("+")
  return ["Ctrl", ...parts].join("+")
}
